







import { Vue, Component } from "vue-property-decorator";
import Welcome from "@share/welcome/Welcome.vue";
import OnboardingSettings from "./components/OnboardingSettings.vue";
import { getBackend } from "@service/router/getters";
import { RouteNamesEnum } from "@service/router/RouteNamesEnum";

@Component({
    name: "Onboarding",
    components: { Welcome, OnboardingSettings }
})
export default class Onboarding extends Vue {
    isFinalize = false;

    // Onboarding profile
    get profile() {
        return this.$store.getters['events/selectedEventViewParam']('profile', {});
    }

    get showOnboardingSettings() {
        return !this.isRouteNoneOnboarding && this.profile?.showOnboardingModal && !this.onbordingDataExist && !this.isFinalize;
    }

    get onbordingDataExist() {
        return this.onbordingData[this.selectedEventId] || !this.lsKey
    }

    get onbordingData() {
        return JSON.parse(localStorage.getItem(this.lsKey) ?? '{}');
    }

    // ключ для localStorage
    get lsKey() {
        return this.backend ? this.backend + '_onboarding_' + this.userId : '';
    }

    get backend() {
        return getBackend(this.$route.params.backend)
    }

    get userId() {
        return this.$store.state.session.userId;
    }

    get isRouteNoneOnboarding() {
        const noneOnboardingRoutes: string[] = [RouteNamesEnum.viewMeetingPublic];
        return noneOnboardingRoutes.includes(this.$route.name || '');
    }

    finalize() {
        const data = this.onbordingData;
        data[this.selectedEventId] = true;
        localStorage.setItem(this.lsKey, JSON.stringify(data));
        this.isFinalize = true;
        this.$emit('done')
    }

    // Welcome Tour
    get selectedEvent() {
        return this.$store.getters['events/selectedEvent'];
    }

    get selectedEventId() {
        return this.selectedEvent?.id;
    }

    get welcomeTourSlides() {
        const welcomeTour = this.$store.getters['events/selectedEventViewParam']('welcomeTour');
        if (welcomeTour && welcomeTour.slides) {
            return welcomeTour.slides;
        }
        return [];
    }

    get showWelcomeTour() {
        const event = this.selectedEvent;
        return !this.showOnboardingSettings && event && !event.isWelcomeTourDone;
    }

    welcomeTourDone() {
        this.$store.dispatch('events/setWelcomeTourFlagDone', this.selectedEvent.id);
        this.isFinalize = true;
    }
}
